@if (field) {
  <div class="form-group">
    <label>
      <span>{{ field.label }}</span>
      <span class="text-danger">{{ field.required ? "*" : "" }}</span>
    </label>
    <ng-container *ngTemplateOutlet="tableViewTpl"></ng-container>
    <ng-container *ngTemplateOutlet="mobileViewTpl"></ng-container>
    <div class="text-end">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary mt-2"
        (click)="openModal(myModal)"
        [disabled]="disabled"
      >
        <i class="mdi mdi-plus"></i> Add New
      </button>
    </div>
  </div>
}

<!-- Table view template. This renders in desktop/tablet screens but will be hidden on mobile screens. -->
<ng-template #tableViewTpl>
  <div class="table-wrapper">
    <table
      class="table table-centered table-bordered table-striped mb-0 d-none d-sm-table"
    >
      <thead>
        <tr>
          @for (subfield of visibleFields; track subfield.name) {
            <th>{{ subfield.label }}</th>
          }
          <th class="action-col"></th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows$ | async; track row.id) {
          @if (!row.value.error) {
            <tr>
              @for (subfield of visibleFields; track subfield.name) {
                <td
                  [class.d-tablet-hidden]="
                    subfield.columnVisibility?.tablet === false
                  "
                  [class.d-desktop-hidden]="
                    subfield.columnVisibility?.desktop === false
                  "
                >
                  @if (
                    customColumnTpls &&
                    subfield.customColumnTplId &&
                    customColumnTpls[subfield.customColumnTplId]
                  ) {
                    @if (
                      customColumnTpls[subfield.customColumnTplId]["desktop"]
                    ) {
                      <ng-container
                        *ngTemplateOutlet="
                          customColumnTpls[subfield.customColumnTplId][
                            'desktop'
                          ];
                          context: {
                            $implicit: row,
                            formattedValue: (row.value | valueFor: subfield),
                          }
                        "
                      ></ng-container>
                    } @else {
                      <ng-container
                        *ngTemplateOutlet="
                          customColumnTpls[subfield.customColumnTplId];
                          context: {
                            $implicit: row,
                            formattedValue: (row.value | valueFor: subfield),
                          }
                        "
                      ></ng-container>
                    }
                  } @else {
                    {{ row.value | valueFor: subfield }}
                  }
                </td>
              }
              <td class="action-col">
                @if (
                  customColumnTpls &&
                  field.customActionsTplId &&
                  customColumnTpls[field.customActionsTplId]
                ) {
                  @if (customColumnTpls[field.customActionsTplId]["desktop"]) {
                    <ng-container
                      *ngTemplateOutlet="
                        customColumnTpls[field.customActionsTplId]['desktop'];
                        context: {
                          $implicit: row,
                          triggerAction: triggerActionFn,
                        }
                      "
                    ></ng-container>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="
                        customColumnTpls[field.customActionsTplId];
                        context: {
                          $implicit: row,
                          triggerAction: triggerActionFn,
                        }
                      "
                    ></ng-container>
                  }
                } @else {
                  <ng-container
                    *ngTemplateOutlet="
                      defaultActionsTpl;
                      context: {
                        $implicit: row.id,
                      }
                    "
                  ></ng-container>
                }
              </td>
            </tr>
          } @else {
            <tr class="gap">
              <td [attr.colspan]="visibleFields.length">
                {{ row.value.error }}
              </td>
              <td class="action-col">
                @if (row.value.fieldName) {
                  <a
                    href="javascript: void(0);"
                    class="action-icon me-1"
                    (click)="openModalForGap(myModal, row)"
                  >
                    <i class="mdi mdi-plus"></i> Add
                  </a>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</ng-template>

<!-- Mobile view template. This renders in mobile screen but will be hidden on desktop/tablet screens. -->
<ng-template #mobileViewTpl>
  <div class="d-block border-top d-sm-none">
    @for (row of rows$ | async; track row.id) {
      @if (!row.value.error) {
        <div class="p-1 w-100 border-bottom">
          @for (subfield of field.subFields; track subfield.name) {
            @if (
              !subfield.columnVisibility ||
              subfield.columnVisibility.mobile !== false
            ) {
              <div>
                <label class="font-weight-bold me-1"
                  >{{ subfield.label }}:</label
                >
                @if (
                  customColumnTpls &&
                  subfield.customColumnTplId &&
                  customColumnTpls[subfield.customColumnTplId]
                ) {
                  @if (customColumnTpls[subfield.customColumnTplId]["mobile"]) {
                    <ng-container
                      *ngTemplateOutlet="
                        customColumnTpls[subfield.customColumnTplId]['mobile'];
                        context: {
                          $implicit: row,
                          formattedValue: (row.value | valueFor: subfield),
                        }
                      "
                    ></ng-container>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="
                        customColumnTpls[subfield.customColumnTplId];
                        context: {
                          $implicit: row,
                          formattedValue: (row.value | valueFor: subfield),
                        }
                      "
                    ></ng-container>
                  }
                } @else {
                  <span>{{ row.value | valueFor: subfield }}</span>
                }
              </div>
            }
          }

          <div class="action-buttons">
            @if (
              customColumnTpls &&
              field.customActionsTplId &&
              customColumnTpls[field.customActionsTplId]
            ) {
              @if (customColumnTpls[field.customActionsTplId]["mobile"]) {
                <ng-container
                  *ngTemplateOutlet="
                    customColumnTpls[field.customActionsTplId]['mobile'];
                    context: {
                      $implicit: row,
                      triggerAction: triggerActionFn,
                    }
                  "
                ></ng-container>
              } @else {
                <ng-container
                  *ngTemplateOutlet="
                    customColumnTpls[field.customActionsTplId];
                    context: {
                      $implicit: row,
                      triggerAction: triggerActionFn,
                    }
                  "
                ></ng-container>
              }
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  defaultActionsMobileTpl;
                  context: {
                    $implicit: row.id,
                  }
                "
              ></ng-container>
            }
          </div>
        </div>
      } @else {
        <div class="address-block border-bottom">
          <div class="w-100 text-danger">
            {{ row.value.error }}
          </div>
          <div class="action-buttons">
            <a
              href="javascript: void(0);"
              class="action-icon me-1"
              (click)="openModalForGap(myModal, row)"
            >
              <i class="mdi mdi-plus mdi-18px"></i> Add
            </a>
          </div>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #defaultActionsTpl let-rowId>
  <a
    href="javascript: void(0);"
    class="action-icon me-1"
    (click)="openModal(myModal, rowId)"
  >
    <i class="mdi mdi-pencil"></i>
  </a>
  <a
    href="javascript: void(0);"
    class="action-icon"
    (click)="deleteRow(rowId)"
  >
    <i class="mdi mdi-delete"></i>
  </a>
</ng-template>

<ng-template #defaultActionsMobileTpl let-rowId>
  <a
    href="javascript: void(0);"
    class="action-icon me-1"
    (click)="openModal(myModal, rowId)"
  >
    <i class="mdi mdi-pencil mdi-18px"></i>
  </a>
  <a
    href="javascript: void(0);"
    class="action-icon"
    (click)="deleteRow(rowId)"
  >
    <i class="mdi mdi-delete mdi-24px"></i>
  </a>
</ng-template>

<ng-template #myModal let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="standard-modalLabel">
      {{ updatingId !== null ? "Edit Item" : "Add Item" }}
    </h4>
    <button type="button" class="close" (click)="d()">x</button>
  </div>
  <div class="modal-body">
    <app-dynamic-form
      [fields]="field.subFields"
      [form]="form"
      [markAsTouched]="markAsTouched"
    ></app-dynamic-form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save(subform)">
      Save changes
    </button>
    <button type="button" class="btn btn-light" (click)="d()">Close</button>
  </div>
</ng-template>
